const state = { 
  query: '办公',
}
const getters = {
  query: state => state.query,
};
// mutations
const mutations = {
  SET_QUERY (state, query) { 
    state.query = query; 
  },
  
}
const actions = {
  setQuery({ commit }, query) {
      commit('SET_QUERY', query);
  },
};

export default {
  state,
  getters,
  mutations,
  actions
}
